export default __webpack_public_path__ + "static/media/itpedia.d533938f.mp4";